import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { ɵDomAdapter as DomAdapter, DOCUMENT, ɵgetDOM as getDOM} from '@angular/platform-browser';
import * as platformBrowser  from '@angular/platform-browser';

export interface HrefLangDefinition {
  rel?: string;
  href?: string;
  hreflang?: string;
}


@Injectable()
export class HrefLang {
  private _dom: DomAdapter;

  constructor( @Inject(DOCUMENT) private _doc: any, @Inject(PLATFORM_ID) private platformId:Object) { this._dom = getDOM(); }

  addLang(lang:string){
    if(isPlatformServer(this.platformId)){
      this._dom.setAttribute(this._doc.head.parent,'lang',lang);
    }
  }

  addTags(...tags: Array<HrefLangDefinition | HrefLangDefinition[]>): HTMLLinkElement[] {
    if (isPlatformServer(this.platformId)) { // Avoid readding the meta tags in client
      const presentTags = this._flattenArray(tags);
      if (presentTags.length === 0) return [];
      return presentTags.map((tag: HrefLangDefinition) => this._addInternal(tag));
    }
  }

  private _addInternal(tag: HrefLangDefinition): HTMLLinkElement {
    const meta: HTMLLinkElement = this._createLinkElement();
    this._prepareMetaElement(tag, meta);
    this._appendMetaElement(meta);
    return meta;
  }

  private _createLinkElement(): HTMLLinkElement {
    return this._dom.createElement('link') as HTMLLinkElement;
  }

  private _prepareMetaElement(tag: HrefLangDefinition, el: HTMLLinkElement): HTMLLinkElement {
    Object.keys(tag).forEach((prop: string) => this._dom.setAttribute(el, prop, tag[prop]));
    return el;
  }

  private _appendMetaElement(meta: HTMLLinkElement): void {
    const head = this._doc.head;    
    try {
    this._dom.removeChild(head,meta);
    }
    catch (ex) {}
    this._dom.appendChild(head, meta);
  }

  private _flattenArray(input: any[], out: any[] = []): any[] {
    if (input) {
      for (let i = 0; i < input.length; i++) {
        const item: any = input[i];
        if (Array.isArray(item)) {
          this._flattenArray(item, out);
        } else if (item) {
          out.push(item);
        }
      }
    }
    return out;
  }
}
